import { getAgentForm } from "../../../selectors/personalPensionPlan/agentModal";
import { getPersonalDetailsForm } from "../../../selectors/personalPensionPlan/personalDetails";
import { getPremiumCalculation } from '../../../selectors/personalPensionPlan/quote';
import { getDocumentsForm } from '../../../selectors/personalPensionPlan/documents';
import { getQuoteForm } from "../../../selectors/personalPensionPlan/quote";
import { getAccessToken } from '../../../selectors/personalPensionPlan/payments';
import { getIsApiPending } from '../../../selectors/personalPensionPlan/personalDetails';
import axios from 'axios';
import { apiTransitionPersonalDetailsForm, setCustomerIdValue } from "../../../actions/personalPensionPlan/personalDetails";
import format from 'date-fns/format'
import { apiTransitionPayloadCollection } from "../../../actions/personalPensionPlan/payloadCollection";
import { setExpiredAuth } from "../../../actions/personalPensionPlan/quote";

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const payloadPersonalDetailsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPersonalDetailsForm.pending());
            try {
                const res = await makeSubmission(store.getState());

                if(res.data) {
                    store.dispatch(setCustomerIdValue(res.data.data.id))
                    store.dispatch(apiTransitionPersonalDetailsForm.success());
                }

            } catch (e) {
                console.error(e);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitionPersonalDetailsForm.failure());
            }
        }
    })();
    return next(action);
}

function calculateNextBirthdayAge(birthdate) {
    const [day, month, year] = birthdate.split('/').map(Number);

    const birthDate = new Date(year, month - 1, day);

    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    const currentYearBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
    if (today < currentYearBirthday) {
        age--;
    }

    return age + 1;
}

const payloadCollection = (state) => {
    const personalDetails = getPersonalDetailsForm(state);
    const agent = getAgentForm(state);
    const quotation = getQuoteForm(state);
    const premiumCalculation = getPremiumCalculation(state);
    const documents = getDocumentsForm(state);

    const agentPayload = {
        agentCode: gatsbyStack === 'ke' ? agent.name?.value?.agentCode || 'N/A' : agent.agentCode?.value || 'N/A',
        agentName: gatsbyStack === 'ke' ? agent.name?.value?.name || 'N/A' : agent.name?.value || 'N/A',
        referredByAgent: gatsbyStack === 'ke' && agent.name?.value?.name ? true : agent.name?.value ? true : false,
    };

    const payload = {
        countryCode: gatsbyStack.toUpperCase(),
        refferer: `${agentPayload.agentCode}`,
        plan: 'Personal Pension Plan(Segregated)',
        ageNextBirthDay: calculateNextBirthdayAge(personalDetails.dob.value),
        monthlySalary: 0,
        annualSalary: 0,
        monthlyPremium: premiumCalculation?.value?.monthPremium ? premiumCalculation?.value?.monthPremium : 0,
        futureValue: premiumCalculation?.value?.futureValue ? premiumCalculation?.value?.futureValue : 0,

        firstName: personalDetails.firstName.value,
        lastName: personalDetails.lastName.value,
        dateOfBirth: convertDateFormat(personalDetails.dob.value),
        gender: quotation.gender.value,
        occupation: personalDetails.occupation.value,
        idNumber: personalDetails.idNumber.value,
        idNumberDoc: documents.idUpload.value.base64File,
        kraPin: personalDetails.tinNumber.value,
        kraPinDoc: documents.kraPinUpload.value.base64File,
        phoneNumber: personalDetails.phoneNumber.value,
        emailAddress: personalDetails.email.value,
        postalAddress: 'N/A',
        lumpsum: quotation.lumpsumAmount?.value ? quotation.lumpsumAmount?.value : '0',
        monthlyContribution: premiumCalculation?.value?.monthPremium
            ? premiumCalculation?.value?.monthPremium.toString()
            : '0',
        isLumpsumPrepaid: quotation.isLumpsumPrepaid?.value === 'yes' ? true : false,
        mpesaPhoneNumber: 'N/A',
        crmPulled: false,
        sourceOfFunds: personalDetails.occupation.value,
    }

    return {
        ...payload,
    };
}

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-pension-plan/personal-details';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

function convertDateFormat(dateString) {
    try {
        // Split the date string into year, month, and day
        var parts = dateString.split('/');
        var year = parts[2];
        var month = parts[1];
        var day = parts[0];

        // Reformat the date string in the desired format
        var formattedDate = `${year}-${month}-${day}` ;

        return formattedDate;
    } catch (error) {
        // Handle the case where the input string is not in the expected format
        return 'Invalid date format. Please use yyyy-mm-dd.';
    }
}